import Vue from "vue";
import Router from "vue-router";
import HomeScreen from "./screens/Screen.vue";
import AboutScreen from "./screens/About/Screen.vue";
import CourseScreen from "./screens/Course/Screen.vue";
import PubScreen from "./screens/Pub/Screen.vue";
import PubDetailScreen from "./screens/PubDetail/Screen.vue";
import ZhaopingScreen from "./screens/Zhaoping/Screen.vue";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", name: "home", component: HomeScreen },
    { path: "/about", name: "about", component: AboutScreen },
    { path: "/course", name: "course", component: CourseScreen },
    { path: "/pub", name: "pub", component: PubScreen },
    { path: "/pub-detail", name: "pub-detail", component: PubDetailScreen },
    { path: "/zhaoping", name: "zhaoping", component: ZhaopingScreen },
  ],
});

router.afterEach(() => {
  Vue.nextTick(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  });
});

export default router;
